import { render, staticRenderFns } from "./childEquipment.vue?vue&type=template&id=837e537c&scoped=true&"
import script from "./childEquipment.vue?vue&type=script&lang=js&"
export * from "./childEquipment.vue?vue&type=script&lang=js&"
import style0 from "./childEquipment.vue?vue&type=style&index=0&id=837e537c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837e537c",
  null
  
)

export default component.exports